import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AprovarAcaoModal from './aprovaracaomodal'
import { aprovarAcao, clearAprovarAcao, fetchJanelaCheck } from './redux/aprovaracaoActions'
import './aprovaracao.scss'

const AprovarAcao = ({
  open,
  close,
  planoId,
  tipoPlano,
  nivel,
  nomePlano,
  onSuccess
}) => {
  const dispatch = useDispatch()
  const { sistema } = useSelector(state => state.layoutState)
  const { loadingJanela, loadingSubmit, janela, error } = useSelector(
    state => state.pdcaState.pdcaAprovarAcaoState
  )

  const [dataFinalCheck, setDataFinalCheck] = useState('')

  const nls = require(`./nls/${sistema.idioma}.json`)

  useEffect(() => {
    if (open && planoId) {
      dispatch(fetchJanelaCheck(planoId))
    }
  }, [dispatch, open, planoId])

  useEffect(() => {
    if (open && janela?.dataRecomendada) {
      setDataFinalCheck(janela.dataRecomendada)
    }
  }, [open, janela])

  useEffect(() => {
    if (!open) {
      setDataFinalCheck('')
      dispatch(clearAprovarAcao())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && error && !loadingJanela && !loadingSubmit) {
      setDataFinalCheck('')
      dispatch(clearAprovarAcao())
      close()
    }
  }, [dispatch, open, error, loadingJanela, loadingSubmit, close])

  const handleClose = () => {
    setDataFinalCheck('')
    dispatch(clearAprovarAcao())
    close()
  }

  const handleChangeDataFinalCheck = e => {
    setDataFinalCheck(e.target.value)
  }

  const handleConfirmar = async () => {
    if (!dataFinalCheck) {
      return
    }

    const sucesso = await dispatch(
      aprovarAcao({
        planoId,
        dataFinalCheck
      })
    )

    if (sucesso) {
      dispatch(clearAprovarAcao())
      setDataFinalCheck('')
      onSuccess()
    }
  }

  return (
    <AprovarAcaoModal
      open={open}
      close={handleClose}
      nls={nls}
      nomePlano={nomePlano}
      tipoPlano={tipoPlano}
      nivel={nivel}
      dataFinalCheck={dataFinalCheck}
      dataInicialMin={janela?.dataInicial || ''}
      dataFinalMax={janela?.dataFinal || ''}
      loadingJanela={loadingJanela}
      loadingSubmit={loadingSubmit}
      onChangeDataFinalCheck={handleChangeDataFinalCheck}
      onConfirmar={handleConfirmar}
    />
  )
}

export default AprovarAcao